document.querySelectorAll('.product-size-popup__open').forEach(button => {
  button.addEventListener('click', function () {
    document.querySelector('.product-size-popup').classList.add('visible');
    document.querySelector('.product-size-popup__overlay').classList.add('visible');
    document.body.classList.add('overflow-hidden');
    document.querySelector('.product__info-container.product__column-sticky').style.zIndex = '102';


  });
});

document.querySelectorAll('.product-size-popup__overlay, .product-size-popup__close').forEach(element => {
  element.addEventListener('click', function () {
    document.querySelector('.product-size-popup').classList.remove('visible');
    document.querySelector('.product-size-popup__overlay').classList.remove('visible');
    document.body.classList.remove('overflow-hidden');
    document.querySelector('.product__info-container.product__column-sticky').style.zIndex = '2';
  });
});


const targetNode = document.querySelector('.product-size-popup__content');

if (targetNode) {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length > 0) {
        const table = document.querySelector('.product-size-popup table');
        const ths = table.querySelectorAll('th'); // Get all <th> elements

        table.querySelectorAll('tr').forEach(row => {
          row.querySelectorAll('td').forEach((td, index) => {
            if (ths[index]) {
              td.setAttribute('data-th', ths[index].textContent.trim());
            }
          });
        });
      }
    });
  });

  observer.observe(targetNode, { childList: true, subtree: true });
}